import { combineReducers } from '@reduxjs/toolkit';
import entities from './entities';
import authReducers from '../auth/store/index';
import decisionLogic from './decisionLogic';

/// Aqui colocar el de auth store

const rootReducer = combineReducers({
	auth: authReducers,
	entities,
	decisionLogic,
});

export default rootReducer;
